import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { ModalHelper } from '@services/modal-helper.service';
import { AccountPaymentService, IAutoCompletePrediction, IDeviceCompatibilityV1, IFirebaseAddress, MobileCustomPlansServiceNoSync, PlacesAutocompleteService } from '@ztarmobile/zwp-service-backend';
import { EquipmentService } from '@ztarmobile/zwp-service-backend-v2';
import { Observable, Subscription } from 'rxjs';
import { ATT, CAPTCHA_BOT_ERROR_CODE, PARAM_ERROR_MESSAGES, TMO } from 'src/app/app.config';
import { ACTIVATION_ROUTE_URLS, SUPPORT_ROUTE_URLS } from 'src/app/app.routes.names';
import { AppState } from 'src/app/app.service';
import { ContentfulService } from 'src/services/contentful.service';
import { ToastrHelperService } from 'src/services/toast-helper.service';

@Component({
  selector: 'app-landing-coverage',
  templateUrl: './landing-coverage.component.html',
  styleUrls: ['./landing-coverage.component.scss']
})
export class LandingCoverageComponent implements OnInit, OnDestroy {
  @ViewChild('formCtrl') compatibilityForm: NgForm;
  public processingRequest: boolean;
  public landingFaqs;
  public questionId: string;
  public collapsed = false;
  public recaptchaResponse: any;
  public recaptchaResolvedSubscription: Subscription;
  public invalidAddress = false;
  public displayedAddressModel: any;
  public address: any;
  public setFoucs = false;
  public displayValidation = false;
  public networkType: string;
  public filteredOptions: Observable<Array<IAutoCompletePrediction>>;
  public filteredOptionsSubscription: Subscription;
  public compatibleDevice: IDeviceCompatibilityV1;
  private streetSearchText: string;

  constructor(public router: Router, private contentfulService: ContentfulService,
    private mobilePlansService: MobileCustomPlansServiceNoSync, public toastHelper: ToastrHelperService,
    private placesAutoCompleteService: PlacesAutocompleteService,
    private equipmentService: EquipmentService,
    private appState: AppState, private modalHelper: ModalHelper) {

  }

  ngOnInit(): void {
    this.landingFaqs = this.contentfulService.getQuestionsByCategoryId('faqs', 'coverage');
  }

  ngOnDestroy(): void {
    this.filteredOptionsSubscription?.unsubscribe();
    if (this.recaptchaResolvedSubscription) {
      this.recaptchaResolvedSubscription.unsubscribe();
    }
  }

  public findPlace(keyword: ''): Observable<Array<IAutoCompletePrediction>> {
    this.filteredOptions = this.placesAutoCompleteService.findAddress(keyword);
    this.filteredOptionsSubscription = this.filteredOptions.subscribe();
    return this.filteredOptions;
  }

  public addressDetails(eventFire: IAutoCompletePrediction): void {
    if (!!eventFire && !!this.address && this.address?.main_text) {
      const event = this.address;
      if (!!event.place_id) {
        this.appState.loading = true;
        this.invalidAddress = false;
        this.displayValidation = false;
        //this is a default value until address have the value from api
        this.address = event?.main_text;
        this.placesAutoCompleteService
          .findDetailedAddressFields(event.place_id)
          .subscribe(
            (place) => {
              this.streetSearchText =
                !!place.address1 && place.address1.length > 0
                  ? place.address1
                  : null;
              this.displayedAddressModel = this.getAddressValues(
                place,
                event.main_text
              );
              this.address = `${this.displayedAddressModel?.address1}, ${this.displayedAddressModel?.city
                }, ${this.displayedAddressModel?.state} ${this.displayedAddressModel?.postalCode
                  ? this.displayedAddressModel?.postalCode
                  : ''
                }`;
              this.appState.loading = false;
            },
            (error) => {
              this.appState.loading = false;
              console.warn(
                `Google can't find details for place: ${event.place_id}`,
                error
              );
            }
          );
      } else {
        this.invalidAddress = true;
        this.displayValidation = false;
        console.warn(`Google can't find place: ${event.main_text}`);
      }
    } else {
      this.invalidAddress = true;
    }
  }

  public changedAddress(): void {
    this.findPlace(this.address);
    this.displayedAddressModel = null;
  }

  public goToCoverage(): void {
    const action = 'freeup_check_address_coverage';
    if (!!this.address && !!this.displayedAddressModel) {
      this.processingRequest = true;
      this.appState.loading = true;
      this.appState.resetAndExecuteCaptchaSubject.next({action});
      this.displayValidation = false;
      this.recaptchaResolvedSubscription= this.appState.resolvedCaptcha.subscribe(response => {
        this.recaptchaResponse = response;
         if(!!this.recaptchaResponse) {
          this.recaptchaResolvedSubscription?.unsubscribe();
          this.callCheckCoverageApi(this.recaptchaResponse, true, action);
         }
      });
    } else if (!this.displayedAddressModel && !this.address) {
      this.displayValidation = true;
    }
  }
  public callCheckCoverageApi(captchaRes, invisibleCaptchaRes, action?): void {
    this.equipmentService.checkNetworkCoverageByAddress(captchaRes, this.displayedAddressModel?.postalCode,
      this.displayedAddressModel?.address1, this.displayedAddressModel?.city,
      this.displayedAddressModel?.state, this.displayedAddressModel?.address2, !!action?action:null, invisibleCaptchaRes).then(res => {
        if (!!res) {
          this.processingRequest = false;
          this.appState.loading = false;
          const tmoCoverage = res.coveredNetworks.find(i => i.network.toLowerCase() === TMO.toLowerCase());
          const attCoverage = res.coveredNetworks.find(i => i.network.toLowerCase() === ATT.toLowerCase());
          // Select ATT coverage first then TMO
          const defaultNetwork = !!attCoverage ? attCoverage : tmoCoverage;
          if (!!res.covered) {
            this.networkType = defaultNetwork?.network || ATT; // just to detault to ATT
            this.generatePhoneDetails(defaultNetwork);
            this.mobilePlansService.setPlanDevice(this.compatibleDevice);
            this.goToCoverageResults();
          }
        }
      }, (error) => {
        this.handleCompatbilityError(error);
      }).catch((error)=>{
        this.handleCompatbilityError(error);
      })
  }
  // renamed from populate to diffrenciate that we have no phone details coming from the API, we are just setting the network and the address
  public generatePhoneDetails(phoneDetails) {
    this.compatibleDevice = phoneDetails as IDeviceCompatibilityV1 || { network: ATT } as IDeviceCompatibilityV1;
    this.compatibleDevice.address1 = this.displayedAddressModel?.address1;
    this.compatibleDevice.address2 = this.displayedAddressModel?.address2;
    this.compatibleDevice.city = this.displayedAddressModel?.city;
    this.compatibleDevice.state = this.displayedAddressModel?.state;
    this.compatibleDevice.postalCode = this.displayedAddressModel?.postalCode;
  }
  public goToCoverageResults() {
    const params = {};
    params[SUPPORT_ROUTE_URLS.PARAMS.NETWORKTYPE] = this.networkType;
    params[ACTIVATION_ROUTE_URLS.PARAMS.ZIP_CODE] = this.displayedAddressModel?.postalCode;
    this.router.navigate([`${SUPPORT_ROUTE_URLS.BASE}/${SUPPORT_ROUTE_URLS.COVERAGE}`, params]);
  }
  public handleCompatbilityError(error) {
    this.recaptchaResolvedSubscription?.unsubscribe();
    this.processingRequest = false;
    this.appState.loading = false;
    this.displayValidation = false;
    const errorDetails = error?.error?.errors?.[0];
    if (errorDetails?.code === CAPTCHA_BOT_ERROR_CODE) {
      this.modalHelper.showRecaptchaVerificationModal().afterClosed().subscribe((result) => {
        if (!!result) {
          this.processingRequest = true;
          this.appState.loading = true;
          this.callCheckCoverageApi(result, false);
        }
      });
    } else {
      let errorMessage = errorDetails?.message;
      if (errorDetails?.code === 102) {
        const paramMessage = errorDetails.params[0]?.message;
  
        if (paramMessage === 'Invalid zip code') {
          errorMessage = PARAM_ERROR_MESSAGES.ADDRESS;
        }
      }
  
      // If it's not a compatibility error, use the original error message
      errorMessage = errorMessage || errorDetails?.message || PARAM_ERROR_MESSAGES.GENERIC;
      this.toastHelper.showAlert(errorMessage);
    }
  }
  public checkYourPhone(): void {
    this.router.navigate([`${ACTIVATION_ROUTE_URLS.BASE}/${ACTIVATION_ROUTE_URLS.CHECK_PHONE}`]);
  }

  public toggleActive(targetId, answerId): void {
    if (this.questionId === targetId && !this.collapsed) {
      this.questionId = 'q0';
    } else {
      this.questionId = targetId;
      this.collapsed = false;
      this.callRichText(answerId);
    }
  }

  private callRichText(id): void {
    this.contentfulService.getRichText('questions', id);
  }

  private getAddressValues(
    placeInfo: any,
    searchTerms?: string
  ): IFirebaseAddress {
    let address: IFirebaseAddress = {
      name: !!this.displayedAddressModel?.name
        ? this.displayedAddressModel?.name
        : this.displayedAddressModel?.alias,
      address1: placeInfo.address1,
      address2: placeInfo.address2,
      state: placeInfo.state ? placeInfo.state.toUpperCase() : placeInfo.state,
      city: placeInfo.city,
      country: placeInfo.country || 'United States',
      postalCode: placeInfo.postalCode,
    } as IFirebaseAddress;

    if (!!this.displayedAddressModel?.id) {
      address.id = this.displayedAddressModel?.id;
      address.isDefault = this.displayedAddressModel?.isDefault;
    }
    if (!!searchTerms && typeof searchTerms === 'string') {
      if (!!this.streetSearchText) {
        if (!searchTerms.match(this.streetSearchText)) {
          this.streetSearchText = null;
        }
      }
      address.address1 = !!this.streetSearchText
        ? address.address1
        : searchTerms.trim();
    }
    if (!!address && address.address1)
      address.address1 = AccountPaymentService.shortenAddress(address.address1, 30);

    // Clean Out empty values,
    address = this.appState.removeEmptyValues(address);
    return Object.assign({}, address);
  }

}
